import { HealthEvent, OutageSpan } from "@inrange/building-manager-api-client";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatSiteDateTime } from "./healthDateFilters";

export const InverterOutageSpans = ({
  event,
  expandedSpans,
  setExpandedSpans,
  readingsUrl,
  timeZone,
}: {
  event: HealthEvent;
  expandedSpans: Set<number>;
  setExpandedSpans: React.Dispatch<React.SetStateAction<Set<number>>>;
  readingsUrl: (
    eventSiteId: string,
    startDate: string,
    endDate: string,
    esysUuid?: string | null
  ) => string;
  timeZone: string;
}) => {
  const spans = event.details?.outage_spans as OutageSpan[] | undefined;
  if (!Array.isArray(spans) || spans.length === 0) return null;

  const isExpanded = expandedSpans.has(event.id);
  return (
    <>
      {" "}
      <Button
        variant="link"
        size="sm"
        className="p-0"
        style={{ fontSize: "0.75rem" }}
        onClick={() => {
          setExpandedSpans((prev) => {
            const next = new Set(prev);
            if (next.has(event.id)) {
              next.delete(event.id);
            } else {
              next.add(event.id);
            }
            return next;
          });
        }}
      >
        {isExpanded ? "Hide spans" : "Show spans"}
      </Button>
      {isExpanded && (
        <ul
          className="mb-0 mt-1"
          style={{ paddingLeft: "1.2rem", fontSize: "0.75rem" }}
        >
          {spans.map((span, i) => (
            <li key={i}>
              {span.serial_number}: {formatSiteDateTime(span.start, timeZone)} →{" "}
              {formatSiteDateTime(span.end, timeZone)} ({span.duration_min} min){" "}
              (
              <Link
                to={readingsUrl(
                  event.siteId,
                  span.start.slice(0, 10),
                  span.end.slice(0, 10),
                  event.esysUuid
                )}
              >
                Readings
              </Link>
              )
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
